/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Confirmed_ToastInputs */

const en_coaching_confirmed_toast = /** @type {(inputs: Coaching_Confirmed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session confirmed.`)
};

const id_coaching_confirmed_toast = /** @type {(inputs: Coaching_Confirmed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesi terkonfirmasi.`)
};

/**
* | output |
* | --- |
* | "Session confirmed." |
*
* @param {Coaching_Confirmed_ToastInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const coaching_confirmed_toast = /** @type {((inputs?: Coaching_Confirmed_ToastInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Confirmed_ToastInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_coaching_confirmed_toast(inputs)
	return en_coaching_confirmed_toast(inputs)
});